import { render, staticRenderFns } from "./channelView.vue?vue&type=template&id=507943b4&scoped=true&"
import script from "./channelView.vue?vue&type=script&lang=js&"
export * from "./channelView.vue?vue&type=script&lang=js&"
import style0 from "./channelView.vue?vue&type=style&index=0&id=507943b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507943b4",
  null
  
)

export default component.exports